/**
 * Compact local-time label, matching the Snapshots and confirmed-dumps lists
 * (`15 Sept, 14:58`). The endpoints return raw ISO precisely so the viewer's own
 * zone is what is shown — no site timezone is plumbed to the server.
 */
export function formatOccurredAt(iso: string): string {
  return new Date(iso).toLocaleString("en-AU", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

/**
 * The same instant in full, for the hover detail: weekday, date, seconds, and
 * the zone — without which an operator comparing this against a device log or a
 * Patriot record cannot tell which offset the compact label was rendered in.
 */
export function formatOccurredAtFull(iso: string): string {
  return new Date(iso).toLocaleString("en-AU", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZoneName: "longOffset",
  });
}
